// src/pages/admin/Certificates/CertificatesManage.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card } from 'antd';

const CertificatesManage = ({ certificates, users }) => {
  const navigate = useNavigate();
  return (
    <Card title="Certificates Management">
      <p>Certificates management page.</p>
      <button onClick={() => navigate('/admin/dashboard')}>Back to Dashboard</button>
    </Card>
  );
};

export default CertificatesManage;